export default [
  {
    path: '/classrooms',
    component: () => import('@/views/classroom/index.vue'),
    name: 'Phòng học',
    meta: {
      title: 'Phòng học',
      auth: true,
    },
  },
  {
    path: '/departments',
    component: () => import('@/views/department/index.vue'),
    name: 'Cơ sở',
    meta: {
      title: 'Cơ sở',
      auth: true,
    },
  },
]
